module.exports = "/_next/static/images/PersonalizationGraphData-a540923516730569f144c6353f6586da.webp";